import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import styled from 'styled-components';
import PromotionItem from '../../base/PromotionItem';
import Styles from './Promotions.styles';
import { isValidArray } from '../../../helpers';

const Mask = styled.div`${Styles.mask}`; // prettier-ignore
const SliderWrapper = styled.div`${Styles.wrapper}`; // prettier-ignore

/**
 * Promotions component
 * @param {Array} items - Promotion items array
 * @returns {JSX}
 */
const Promotions = ({ items }) => {
  const settings = {
    dots: true,
    infinite: true,
    pauseOnHover: true,
    speed: 350,
    slidesToShow: 1,
    autoplaySpeed: 10000,
    autoplay: true,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: 0,
    arrows: false
  };

  if (isValidArray(items)) {
    return (
      <Mask>
        <SliderWrapper className="row">
          <Slider {...settings}>
            {items.map(promotion => (
              <PromotionItem {...promotion} />
            ))}
          </Slider>
        </SliderWrapper>
      </Mask>
    );
  }

  return null;
};

Promotions.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      descriptionColor: PropTypes.string,
      terms: PropTypes.string,
      callToAction: PropTypes.string,
      link: PropTypes.string,
      innerLink: PropTypes.bool,
      backgroundImage: PropTypes.object
    })
  )
};

export default Promotions;
